<template>
    <div>
        <el-card class="box-card">
            <div class="block">
                <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="下行时间开始" class="mr15"></el-date-picker>
                <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="下行时间结束" class="mr15"></el-date-picker>
                <el-button type="primary" @click="clicksearch">查询</el-button>
                <el-button type="info" class="mt20" @click="backDownLinkData">返回</el-button>
            </div>

            <el-table :data="dataList" border stripe class="mt15">
                <el-table-column prop="Mac" label="MAC地址" width="150px"></el-table-column>
                <el-table-column prop="Name" label="会员名称" width="80px"></el-table-column>
                <el-table-column prop="Input" label="训练参数" width="300px"></el-table-column>
                <el-table-column prop="Output" label="数据包"></el-table-column>
                <el-table-column prop="Createtime" label="下行时间" width="160px"></el-table-column>
            </el-table>

          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum"
			  :current-page.sync="selectedPageNo">
            </el-pagination>
          </div>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      keywords: {
        begintime: '',
        endtime: ''
      },
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetDownDatanum()
      this.apigetDownDatalist()
    },
    backDownLinkData () {
      this.$emit('triggerFunc', '')
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetDownDatanum()
      this.apigetDownDatalist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetDownDatalist()
    },
    apigetDownDatalist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDownDatalist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDownDatanum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDownDatanum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
